import { Column } from "primereact/column";
import { useEffect, useInsertionEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DataGrid from "./DataGrid";
import CatService from "../../service/CatService";
import { CommonDialog } from "./CommonDialog";
import KeyValue from "./KeyValue";
import { DataTable } from "primereact/datatable";
import { Form } from "./Form";
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import OrgService from "../../service/OrgService";
import { useTranslation } from "react-i18next";


export function PermGrid({objId,objType,objName})
{
    const {t}=useTranslation();    
    const objectProps=[
        {key:t('Id'),value:objId},
        {key:t('Type'),value:objType},
        {key:t('Name'),value:objName}
    ];
    const [reload,setReload]=useState(false);
    const [selectedPerms,setSelectedPerms]=useState([]);
    const [perms,setPerms]=useState([]);
    const [permPanel,setPermPanel]=useState(false);
    const [perm,setPerm]=useState({});
    const [groups,setGroups]=useState(null);

    const loadRecords=()=>{
        if(objId == undefined || objType == undefined)
            return;
        var searchCrt={objIds:[objId],objType:objType};
        CatService.getCatPerms(objId).then((recs)=>{
            setPerms(recs);
            setSelectedPerms([]);
            setReload(false);
        });
    }
    const loadGroups=()=>{
        OrgService.getUserGroups().then((ret)=>{
            var grps=ret.map(g=>{return {label:g,value:g}})
            setGroups(grps);
        })
    }
    const onInsert=()=>{
        setPerm({objId:objId,objType:objType,subjType:'GROUP',subjId:''})
        setPermPanel(true);
    }
    const onPermChange=(val)=>{
        val.subjId = (val.subjType == 'USER')?val.userId:val.userGroup; 
        setPerm(val);
    }
    const onAddPerm=()=>{
        CatService.insertPerm(perm).then((ret)=>{
            setReload(true);
            setPermPanel(false);
        });
    }
    const onDeleteRecords=(ids)=>{
        var ret = CatService.deletePerms(ids);
        ret.then(()=>{
            setReload(true);
        });
        return ret;
    }
    useEffect(()=>{
        loadRecords(objId,objType,reload);
        loadGroups();
    },[]);
    const inheritedBodyTemplate=(perm)=>{
        if(!perm.inherited)
            return <></>;
        return <icon className="pi pi-check"></icon>;
    }
    const isRowSelectable = (event) => {return (event.data ? !event.data.inherited : true)};
    return(
        <>
            <div className="p-2" style={{width:'600px',height:'500px'}}>
            <KeyValue values={objectProps}></KeyValue>
            <div className="mt-2 mb-5">
                <DataGrid reload={reload} recs={perms} loadRecords={loadRecords} selectedRecs={selectedPerms} 
                        setRecs={setPerms} setSelectedRecs={setSelectedPerms} isDataSelectable={e => isRowSelectable(e)}
                        insertRecord={onInsert} deleteRecords={onDeleteRecords} t={t}
                        parentId={0} insertMenu deleteMenu > 
                    <Column header={t('Id')} field="id" style={{width:'10%'}} sortable/>
                    <Column header={t('Inherited')} field="inherited" style={{width:'10%'}} body={inheritedBodyTemplate} sortable/>
                    <Column header={t('Group')} field="subjId" style={{width:'30%'}} sortable/>
                    <Column header={t('Permission')} field="perm" style={{width:'50%'}} sortable body={(data)=>t('PermType.'+data.perm.replace(':','_'))}/>
                </DataGrid>
            </div>
            {
                permPanel?
                <Panel header={t('New_Permission')}>
                    <PermPanel newPerm={perm} onChange={onPermChange} userGroups={groups}></PermPanel>
                    <div>
                    <Button label={t('Add')} icon="pi pi-check" onClick={onAddPerm} autoFocus />
                    </div>
                </Panel>:''
            }            
            </div>
        </>
    )
}
export function PermPanel({newPerm,onChange,userGroups})
{
    const {t}=useTranslation();        
    const onValChange=(val)=>{onChange(val)};
    const subjTypes = [
        {label: t('SubjType.USER'), value: 'USER'},
        {label: t('SubjType.GROUP'), value: 'GROUP'}
    ];
    const perms = [
        {label: t('PermType.cat_manage'), value: 'cat:manage'},
        {label: t('PermType.cat_delete'), value: 'cat:delete'},
        {label: t('PermType.cat_view'), value: 'cat:view'},
        {label: t('PermType.cms_que_view'), value: 'cms:que:view'},
        {label: t('PermType.cms_que_author'), value: 'cms:que:author'},
        {label: t('PermType.cms_que_delete'), value: 'cms:que:delete'},
        {label: t('PermType.cms_que_approve'), value: 'cms:que:approve'},
        {label: t('PermType.cms_crt_manage'), value: 'cms:crt:manage'}
    ];

    return(
        <>
            <Form id="addPerm" columns="3" formData={newPerm} onChange={onValChange}
                fields={[
                    //{id:"subjType",ftype:"dropdown",field:"subjType",label:"Subject Type",options:subjTypes},
                    {id:"userGroup",ftype:"dropdown",field:"userGroup",label:t('User_Group'),options:userGroups},
                    {id:"perm",ftype:"dropdown",field:"perm",label:t("Permission"),options:perms}
            ]}>
            </Form>	
        </>
    )
}
export function PermDialog({visible,onClose,objId,objType,objName,onHide})
{
    const {t}=useTranslation();
    const _onOK=()=>{
        onClose();
    }
    return(
        <CommonDialog header={t("Perms")} visible={visible} onClose={_onOK} onHide={onHide}>
            <PermGrid objId={objId} objType={objType} objName={objName}></PermGrid>
        </CommonDialog>
    )
}